import React, { Component } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { connect } from "react-redux";

import validator from "validator";
import {
    TextInput,
    SlSectionTitle,
    SlPageTitle,
    SlRadioButton,
    SlButton,
    SlFormEntryRow,
    DatePickerCombo,
    SelectInput
} from "../editors";
import Stepper from "./Stepper";
import { IdentificationType } from "./IdentificationType";
import { registrationActions } from "../../_actions";
import { metadataService, newLoanStepperService, workflowService } from "../../_services";
import { registrationConstants, workflowConstants } from "../../_constants";
import { history } from "../../_helpers";
import { registration } from "../../_reducers/registration.reducer..old";
//import Stepper from "./Stepper";

class SignUpVerifyIdentity extends Component {
    static displayName = SignUpVerifyIdentity.name;

    constructor(props) {
        super(props);
        const stateVals = {
            formValue: {
                DOB: props.dateOfBirth ? props.dateOfBirth : '',
                SSN: props.idNumber,
                IDType: props.isIDSSN ? "SSN" : "MC",
                SSNString: "SSN",
                MCString: "MC",
            },
            validIDLabel: "ValidSSN",
            isIdValid: true,
            //steps: newLoanStepperService("existingLoan")
        };
        stateVals.formError = this.isFormError(stateVals);
        this.state = stateVals;

        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSetState = this.handleSetState.bind(this);
        this.isIdentificationTypeValid = this.isIdentificationTypeValid.bind(this);
    }

    componentDidMount() {
        if (
            this.props.completedSteps.find(
                (t) => t === registrationConstants.PROFILE_CREATE_REQUEST
            )
        ) {
            history.push("/SignUpOptInValidation");
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { ssnItinError } = this.props;
        if (prevProps.ssnItinError !== ssnItinError) {
            let isValid = this.formHasError(this.props);
            this.setState({
                formError: isValid,
                ssnItinError: ssnItinError,
            });
        }
    }

    handleInput = ({ target: { name, value } }) => {

        const formValue = { ...this.state.formValue, [name]: value };
        let newState = {
            formValue: formValue
        };

        if (name == "socialSecurityItin") {
            if (value.SocialSecurityNumber) {
                newState.formValue.SSN = value.SocialSecurityNumber;
                newState.formValue.IDType = "SSN";
            }
            else if (value.IndividualTaxIdentificationNumber) {
                newState.formValue.SSN = value.IndividualTaxIdentificationNumber;
                newState.formValue.IDType = "MC";
            }
            newState.ssnItinError = !value.isValid;
        }

        this.handleSetState(newState);
    };

    handleSetState(stateChange) {
        let newState = { ...this.state, ...stateChange };
        stateChange.formError = this.isFormError(newState);
        this.setState(stateChange);
    }

    handleSubmit = () => {
        const { dispatch } = this.props;
        let formError = this.isFormError(this.state);

        if (!formError) {
            let currentStepData = workflowService.getCurrentWorkflowStepData();
            let currentWorkflowId = currentStepData ? currentStepData.workflowId : null;

            let idTypeAndNumber = {
                dateOfBirth: this.state.formValue.DOB,
                idNumber: this.state.formValue.SSN,
                isIDSSN: this.state.formValue.IDType === "SSN",
                isIDConsular: this.state.formValue.IDType !== "SSN",
                confirmationSummaryScreen: this.props.confirmationSummaryScreen,
                existingCustomer: currentWorkflowId === workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW
            };

            dispatch(
                registrationActions.handleIdTypeAndNumberRequest(idTypeAndNumber)
            );
        }
    };

    isFormError(newState) {
        return newState.ssnItinError || validator.isEmpty(newState.formValue.DOB);
    }

    isIdentificationTypeValid(fieldName, isValid) {
        return { formError: !isValid, ssnItinError: !isValid }
    }

    render() {
        const { validIDLabel } = this.state;

        var identityType = this.state.formValue.IDType == 'MC' ?
            { individualTaxIdentificationNumber: this.state.formValue.SSN } :
            { socialSecurityNumber: this.state.formValue.SSN };

        let currentStepData = workflowService.getCurrentWorkflowStepData();
        let currentWorkflowId = currentStepData ? currentStepData.workflowId : null;

        return (
            <div className="SignUpVerifyIdentity">
                {this.props.steps.length > 0 && (
                    <Stepper stepData={this.props.steps} currentStep={this.props.currentStep} />
                )}

                {currentWorkflowId === workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW ? 
                    <SlFormEntryRow>
                        <SlPageTitle pageName="AccountConfirmation" />
                        <div className="text-center">
                            <p className="mt-4 p-0">{metadataService.getMessage("ExistingCustomerRegistrationIdentity1")}</p>
                        </div> 
                    </SlFormEntryRow>
                :
                    <SlFormEntryRow>
                        <SlPageTitle pageName="SignUpMain" />
                        <SlSectionTitle sectionName="My_Info" />
                    </SlFormEntryRow>
                }
                    
                <Card>
                    <CardBody className="noPadBottom">
                            <IdentificationType
                            name={"socialSecurityItin"}
                            value={identityType}
                            isRequired={true}
                            showLabel={true}
                            fieldErrors={this.state.fieldErrors}
                            onChange={this.handleInput}
                            isValid={(name, isValid) => this.isIdentificationTypeValid(name, isValid)}
                            requireReEntry={true}
                            />

                            <SlFormEntryRow>
                                <TextInput
                                    type="date"
                                    name="DOB"
                                    label={metadataService.getFieldNameLabel("DOB")}
                                    value={this.state.formValue.DOB}
                                    onChange={this.handleInput}
                                    maskOnBlur={true}
                                />
                            </SlFormEntryRow>
                    </CardBody>
                </Card>
                {currentWorkflowId == workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW &&
                    <SlFormEntryRow>
                        <div className="text-center mt-4" dangerouslySetInnerHTML={{ __html: metadataService.getMessage("ExistingCustomerRegistrationIdentity2") }}></div>
                    </SlFormEntryRow>
                }
                <Row className="justify-content-center">
                    <Col xs={12} md={6}>
                        <div className="text-center">
                            <SlButton
                                name={this.props.postingData===true? "Processing": "Next"}
                                onClick={this.handleSubmit}
                                size="lg"
                                disabled={this.state.formError || this.props.postingData===true}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;
    const {
        existingCustomer,
        confirmationSummaryScreen,
        error,
        dateOfBirth,
        monthofBirth,
        dayOfBirth,
        yearOfBirth,
        idNumber,
        isIDSSN,
        isIDConsular,
        completedSteps,
        postingData,
    } = state.registration;

    const { steps, currentStep } = state.users;

    return {
        loggedIn,
        existingCustomer,
        confirmationSummaryScreen,
        error,
        dateOfBirth,
        monthofBirth,
        dayOfBirth,
        yearOfBirth,
        idNumber,
        isIDSSN,
        isIDConsular,
        completedSteps,
        steps,
        currentStep,
        postingData
    };
}

const connectedSignUpVerifyIdentity = connect(mapStateToProps)(
    SignUpVerifyIdentity
);
export { connectedSignUpVerifyIdentity as SignUpVerifyIdentity };
